module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-16-a8afa310e1ec370a8fb5efb9766c2193.jpg";